import React from "react";
import {Col, Row} from "react-bootstrap";
import {trans} from "../../../translations/translations";

const NoBreakComponent = (props) => {

    const {handleCloseDialog} = props;

    return(
        <Row className={"no-break-row justify-content-center pb-4"}>
            <Col xs={12} className={"text-center title mb-3"}>
                <span>{trans('noBreak.text1', 'sos')}</span>
            </Col>
            <Col xs={10} className={"text-center text-dialog mb-3"} >
                <p className={"m-0"}>{trans('noBreak.text2', 'sos')}</p>
                <p className={"m-0"}>{trans('noBreak.text3', 'sos')}</p>
            </Col>
            <Col xs={10}  className={"text-center text-dialog mb-3"} >
                <p className={"m-0"}>{trans('noBreak.text4', 'sos')}</p>
            </Col>
            <Col xs={10}  className={"mb-3 pb-3 text-center text-dialog"} >
                <p className={"m-0"}>{trans('noBreak.text5', 'sos')}</p>
            </Col>
            <Col xs={12} className={"pb-2 pb-sm-0 d-flex align-items-center justify-content-center px-0"}>
                <p className={"m-0 text-link"} onClick={handleCloseDialog}>{trans('btn.close', 'sos')}</p>
            </Col>
        </Row>
    )
}

export default NoBreakComponent;